import(/* webpackMode: "eager" */ "/root/Flare-Backoffice-Nextjs/app/global-error.tsx");
